"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockServer = exports.asyncResponse = void 0;
require("url-search-params-polyfill");
var MockServer_1 = __importDefault(require("./MockServer"));
exports.MockServer = MockServer_1.default;
var asyncResponse_1 = __importDefault(require("./asyncResponse"));
exports.asyncResponse = asyncResponse_1.default;
exports.default = (function (route, client, baseURL) {
    if (baseURL === void 0) { baseURL = ''; }
    return new MockServer_1.default(route, client, baseURL);
});
/* eslint-disable dot-notation */
module.exports = exports['default'];
module.exports.default = exports['default'];
module.exports.asyncResponse = asyncResponse_1.default;
//# sourceMappingURL=index.js.map